import * as Yup from "yup"
import { VALIDATION_REGEX } from "../../config/constants"

export const contactDetailsInitialValues = {
	name: "",
	position: "",
	contactMethod: "",
	phoneOrEmail: "",
	isPrimaryContact: false,
	isActive: false,
}

export const customerInitialValues = {
	name: "",
	telephone: "",
	addressLine1: "",
	addressLine2: "",
	city: "",
	county: "",
	postalCode: "",
	reference1: "",
	reference2: "",
	isActive: false,
	qualifications: [],
	contactDetail: contactDetailsInitialValues,
	allowWorkOnConsecutiveDays: false,
}

export const customerSchema = Yup.object().shape(
	{
		name: Yup.string().required().label("Name").trim().max(100),
		company: Yup.string().required().label("Organization"),
		telephone: Yup.string()
			.nullable()
			.label("Telephone")
			.when("telephone", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.mobile, "Telephone must be in correct format"),
			}),

		addressLine1: Yup.string().nullable().label("Address Line1").trim().max(250),
		addressLine2: Yup.string().nullable().label("Address Line2").trim().max(250),
		city: Yup.string().nullable().label("City").trim().max(20),
		county: Yup.string()
			.transform(value => (value === "" ? null : value))
			.nullable()
			.label("County"),
		postalCode: Yup.string()
			.label("Postal code")
			.nullable()
			.when("postalCode", {
				is: (value: any) => value?.length,
				then: rule => rule.matches(VALIDATION_REGEX.postalCode, "Postal code must be in correct format"),
			}),

		reference1: Yup.string().nullable().label("Reference 1").trim(),
		reference2: Yup.string().nullable().label("Reference 2").trim(),
		qualifications: Yup.array(Yup.string()).label("Required Qualifications"),
		isActive: Yup.boolean().label("Active"),
		contactDetail: Yup.lazy(value => {
			if (value && Object.values(value).every(v => !(v === null || v === undefined || v === ""))) {
				return Yup.object({
					name: Yup.string().required().label("Name"),
					position: Yup.string().required().label("Position"),
					contactMethod: Yup.string().required().label("Contact Method"),
					phoneOrEmail: Yup.string().required().label("Phone or Email"),
					isPrimaryContact: Yup.boolean().required().label("Is Primary Contact"),
					isActive: Yup.boolean().required().label("Is Active"),
				}).notRequired()
			}
			return Yup.mixed().notRequired()
		}),
		allowWorkOnConsecutiveDays: Yup.boolean().label("Enable Consecutive Workdays Check"),
	},
	[
		["postalCode", "postalCode"],
		["telephone", "telephone"],
	],
)
